import { render, staticRenderFns } from "./ScanLabelDialog.vue?vue&type=template&id=6a2e9453"
import script from "./ScanLabelDialog.vue?vue&type=script&lang=js"
export * from "./ScanLabelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports